const components = [
  // b-xxx business 业务组件
  ['b-filter-left', () => import('./business/b-filter-left')],
  ['b-detail-nav', () => import('./business/b-detail-nav')],
  ['b-popup-account', () => import('./business/b-popup-account')],
  ['b-detail-process', () => import('./business/b-detail-process')],
  ['b-detail-step', () => import('./business/b-detail-step')],
  ['b-goods-category', () => import('./business/b-goods-category/index')],
  ['b-goods-texture', () => import('./business/b-goods-texture')],
  ['b-organize-department', () => import('./business/b-organize-department/index')],
  ['b-organize-staff', () => import('./business/b-organize-staff/index')],
  ['b-popup-customer', () => import('./business/b-popup-customer')],
  ['b-popup-customer-follow-up', () => import('./business/b-popup-customer-follow-up')],
  ['b-popup-parent-code', () => import('./business/b-popup-parent-code')],
  ['b-popup-process-step', () => import('./business/b-popup-process-step')],
  ['b-popup-test', () => import('./business/b-popup-test')],
  ['b-popup-verify-goods-detail', () => import('./business/b-popup-verify-goods-detail/index')],
  ['b-popup-verify-goods-edit', () => import('./business/b-popup-verify-goods-edit/index')],
  ['b-popup-verify-goods-view', () => import('./business/b-popup-verify-goods-view/index')],
  ['b-popup-choose-gong-yi', () => import('./business/b-popup-choose-gong-yi')],
  ['b-popup-choose-shang-pin', () => import('./business/b-popup-choose-shang-pin')],

  // c-xxx common 公用组件
  ['c-list-empty', () => import('./common/c-list-empty')],
  ['c-back', () => import('./common/c-back')],
  ['c-table-header', () => import('./common/c-table-header')],
  ['c-cascader-category', () => import('./common/c-cascader-category')],
  ['c-cascader-address', () => import('./common/c-cascader-address')],
  ['c-cascader-industry-category', () => import('./common/c-cascader-industry-category')],
  ['c-cascader-department-member', () => import('./common/c-cascader-department-member')],
  ['c-read-company-address', () => import('./common/c-read-company-address')],

  // e-xxx element-ul 封装组件
  ['e-drawer', () => import('./element-ui/e-drawer')],
  ['e-tabs', () => import('./element-ui/e-tabs')],
  ['e-form', () => import('./element-ui/e-form')],
  ['e-date-picker', () => import('./element-ui/e-date-picker')],
  ['e-upload-file', () => import('./element-ui/e-upload-file')],
  ['e-upload-image', () => import('./element-ui/e-upload-image')],
  ['e-select-array', () => import('./element-ui/e-select-array')]
]

const setComponents = (app) => {
  components.forEach((item) => {
    app.use({
      install(app) {
        app.component(item[0], item[1])
      }
    })
  })
}

export default setComponents
